import { DatePicker, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { PrintCyclenderInput } from "../../../../staff/common/common-functions";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import moment from "moment";

const AuxiliryEngineLog = () => {
  const { eng_log_basic_id } = useParams();
  const [errors, set_errors] = useState({});
  const [cyl_fuel_rack, set_cyl_fuel_rack] = useState([]);
  const [cyl_exhaust_temp, set_cyl_exhaust_temp] = useState([]);
  const [ship_no_of_cylinder, set_ship_no_of_cylinder] = useState(null);
  const [engine_number, set_engine_number] = useState(1);
  const [engine_Numbers, set_Engine_Number] = useState([1, 2, 3, 4]);
  const [number_of_engines_running, set_number_of_engines_running] =
    useState("");
  const [cooling_water_pressure, set_cooling_water_pressure] = useState("");
  const [cooling_water_temp_in, set_cooling_water_temp_in] = useState("");
  const [lube_oil_pressure, set_lube_oil_pressure] = useState("");
  const [lube_oil_temp_in, set_lube_oil_temp_in] = useState("");
  const [fuel_oil_pressure, set_fuel_oil_pressure] = useState("");
  const [fuel_oil_temp, set_fuel_oil_temp] = useState("");
  const [scavenge_air_pressure, set_scavenge_air_pressure] = useState("");
  const [scavenge_air_temp, set_scavenge_air_temp] = useState("");
  const [alternator_bearing_pressure, set_alternator_bearing_pressure] =
    useState("");
  const [alternator_bearing_temp, set_alternator_bearing_temp] = useState("");
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [fuel_Oil_Type, set_Fuel_Oil_Type] = useState("");
  const [other_fuel_oil_type, set_Other_fuel_oil_type] = useState("");
  const [logDate, set_LogDate] = useState(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [load_kw, set_load_kw] = useState("");
  const [turbocharger_rpm, set_turbocharger_rpm] = useState("");

  // Alarm state change
  const [auxi_exhaust_temp, set_auxi_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });

  // Alarm state change ended
  const VIEW_ALARM_API = async () => {
    try {
      const FORM_DATA = new FormData();
      const ship_id = JSON.parse(localStorage.getItem("ship_id"));
      FORM_DATA.append("ship_id", ship_id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.view_alarm_conditions_com, FORM_DATA).then((res) => {
        const alarm_condition_data = res?.alarm_condition_data;
        if (res?.status == true && alarm_condition_data) {
          set_auxi_exhaust_temp(
            JSON.parse(alarm_condition_data.auxi_exhaust_temp)
          );
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } finally {
    }
  };

  const VIEW_AUXILARY_ENGINE_DETAILS_LOGBOOK_API = async () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("engine_number", engine_number);
      post(ApiURL.view_auxiliary_eng_log_com, FORM_DATA).then((res) => {
        const auxiliary_Engine = res?.response_data;
        if (res?.status == true) {
          const local_user = JSON.parse(localStorage.getItem("user_data"));
          const cyl = local_user?.data?.ship_details?.auxiliary_no_of_cylinder;
          set_cyl_exhaust_temp(
            auxiliary_Engine?.cyl_exhaust_temp
              ? JSON.parse(auxiliary_Engine?.cyl_exhaust_temp)
              : Array(cyl).fill("")
          );
          set_cyl_fuel_rack(
            auxiliary_Engine?.cyl_fuel_rack
              ? JSON.parse(auxiliary_Engine?.cyl_fuel_rack)
              : Array(cyl).fill("")
          );
          // set_engine_number(auxiliary_Engine?.number_of_auxiliary_engines);
          set_number_of_engines_running(
            auxiliary_Engine?.number_of_engines_running
          );
          set_cooling_water_pressure(auxiliary_Engine?.cooling_water_pressure);
          set_cooling_water_temp_in(auxiliary_Engine?.cooling_water_temp_in);
          set_lube_oil_pressure(auxiliary_Engine?.lube_oil_pressure);
          set_lube_oil_temp_in(auxiliary_Engine?.lube_oil_temp_in);
          set_fuel_oil_pressure(auxiliary_Engine?.fuel_oil_pressure);
          set_fuel_oil_temp(auxiliary_Engine?.fuel_oil_temp);
          set_scavenge_air_pressure(auxiliary_Engine?.scavenge_air_pressure);
          set_scavenge_air_temp(auxiliary_Engine?.scavenge_air_temp);
          set_alternator_bearing_pressure(
            auxiliary_Engine?.alternator_bearing_pressure
          );
          set_alternator_bearing_temp(
            auxiliary_Engine?.alternator_bearing_temp
          );
          set_Running_Hour(auxiliary_Engine?.auxiliary_running_hours);
          set_Total_Running_Hour(
            auxiliary_Engine?.auxiliary_total_running_hours
          );
          set_Free_Text(auxiliary_Engine?.auxi_comment);
          set_Fuel_Oil_Type(auxiliary_Engine?.fuel_Oil_Type);
          set_Other_fuel_oil_type(auxiliary_Engine?.other_fuel_oil_type);
          set_LogDate(auxiliary_Engine?.date_time_log);
          set_ship_no_of_cylinder(res?.auxi_eng_cylinder);
          set_load_kw(auxiliary_Engine?.load_kw || "");
          set_turbocharger_rpm(auxiliary_Engine?.turbocharger_rpm || "");
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error View auxiliary Engine logbook:", error);
    }
  };

  useEffect(() => {
    VIEW_AUXILARY_ENGINE_DETAILS_LOGBOOK_API();
  }, [engine_number]);

  useEffect(() => {
    VIEW_ALARM_API();
  }, []);

  return (
    <>
      <div className="white-container">
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                showTime
                disabled
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? moment(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Auxiliary Engine Number</label>
              <Select
                value={engine_number}
                placeholder=" -- Select of Engine Number  -- "
                style={{ width: "100%" }}
                onChange={(value) => {
                  set_engine_number(value);
                }}
              >
                {engine_Numbers?.map((number) => (
                  <Select.Option key={number} value={number}>
                    {number}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Number of Engines Running</label>
              <Input
                disabled
                value={number_of_engines_running}
                placeholder="Number of Engines Running"
                onChange={(e) => {
                  set_number_of_engines_running(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Exhaust Temperature (°C)</label>
              <div
                className="row"
                style={{
                  margin: "0px 0px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <PrintCyclenderInput
                  placeholder="Temp"
                  disabled={true}
                  input_number={ship_no_of_cylinder}
                  set_value={set_cyl_exhaust_temp}
                  values={cyl_exhaust_temp}
                  alarm_Data={auxi_exhaust_temp}
                />
              </div>
            </div>
          </div>
          {/* Fuel Rack */}
          <div className="col-6">
            <div className="input-box">
              <label>Fuel Rack</label>
              <div
                className="row"
                style={{
                  margin: "0px 0px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <PrintCyclenderInput
                  placeholder="Rack"
                  disabled={true}
                  input_number={ship_no_of_cylinder}
                  set_value={set_cyl_fuel_rack}
                  values={cyl_fuel_rack}
                  // alarm_Data={fuel_rack}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Running Hour */}
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Running Hour</label>
              <Input
                disabled
                value={running_Hour}
                placeholder="Running Hour "
                onChange={(e) => set_Running_Hour(e.target.value)}
              />
            </div>
          </div>
          {/* Total Running Hour */}
          <div className="col-6">
            <div className="input-box">
              <label>Total Running Hour</label>
              <Input
                disabled
                value={total_Running_Hour}
                placeholder="Total Running Hour"
                onChange={(e) => {
                  set_Total_Running_Hour(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Load (KW)</label>
              <Input
                disabled
                value={load_kw}
                placeholder="Load (KW)"
                onChange={(e) => set_load_kw(e.target.value)}
              />
              {errors?.load_kw && (
                <>
                  <span style={{ color: "red" }}>{errors?.load_kw}</span>
                </>
              )}
            </div>
          </div>
          {/* Turbocharger RPM */}
          <div className="col-6">
            <div className="input-box">
              <label>Turbocharger (RPM)</label>
              <Input
                disabled
                value={turbocharger_rpm}
                placeholder="Turbocharger (RPM)"
                onChange={(e) => {
                  set_turbocharger_rpm(e.target.value);
                }}
              />
              {errors?.turbocharger_rpm && (
                <span style={{ color: "red" }}>{errors?.turbocharger_rpm}</span>
              )}
            </div>
          </div>
        </div>

        {/* Cooling Water */}
        <h3>Cooling Water</h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled
                value={cooling_water_pressure}
                placeholder="Cooling water pressure (Bar)"
                onChange={(e) => {
                  set_cooling_water_pressure(e.target.value);
                }}
              />
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled
                value={cooling_water_temp_in}
                placeholder="Cooling Water Temperature (°C)"
                onChange={(e) => {
                  set_cooling_water_temp_in(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        {/* Lube Oil */}
        <h3>Lube Oil</h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled
                value={lube_oil_pressure}
                placeholder="Cooling water pressure (Bar)"
                onChange={(e) => {
                  set_lube_oil_pressure(e.target.value);
                }}
              />
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled
                value={lube_oil_temp_in}
                placeholder="Cooling Water Temperature (°C)"
                onChange={(e) => {
                  set_lube_oil_temp_in(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        {/* Fuel Oil */}
        <h3>Fuel Oil</h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Fuel Oil Type</label>
              <Select
                disabled
                value={fuel_Oil_Type}
                placeholder=" -- Select of  Fuel Oil Type  -- "
                style={{ width: "100%" }}
                onChange={(value) => set_Fuel_Oil_Type(value)}
              >
                <Select.Option value="VLSFO">VLSFO</Select.Option>
                <Select.Option value="LSMGO">LSMGO</Select.Option>
                <Select.Option value="HSFO">HSFO</Select.Option>
                <Select.Option value="Other">Other</Select.Option>
              </Select>
            </div>
          </div>
          {fuel_Oil_Type === "Other" && (
            <>
              <div className="col-6">
                <div className="input-box">
                  <label>Other fuel oil type</label>
                  <Input
                    disabled
                    value={other_fuel_oil_type}
                    placeholder="Other fuel oil type"
                    onChange={(e) => {
                      set_Other_fuel_oil_type(e.target.value);
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled
                value={fuel_oil_pressure}
                placeholder="Fuel Oil pressure (Bar)"
                onChange={(e) => {
                  set_fuel_oil_pressure(e.target.value);
                }}
              />
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled
                value={fuel_oil_temp}
                placeholder="Fuel Oil Temperature (°C)"
                onChange={(e) => {
                  set_fuel_oil_temp(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        {/* Scavenge Air */}
        <h3>Scavenge Air </h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled
                value={scavenge_air_pressure}
                placeholder="Scavenge Air Pressure (Bar)"
                onChange={(e) => {
                  set_scavenge_air_pressure(e.target.value);
                }}
              />
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled
                value={scavenge_air_temp}
                placeholder="Scavenge Air Temperature (°C)"
                onChange={(e) => {
                  set_scavenge_air_temp(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        {/* Alternator Bearing */}
        <h3>Alternator Bearing </h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled
                value={alternator_bearing_pressure}
                placeholder="Alternator Bearing  Pressure (Bar)"
                onChange={(e) => {
                  set_alternator_bearing_pressure(e.target.value);
                }}
              />
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled
                value={alternator_bearing_temp}
                placeholder="Alternator Bearing  Temperature (°C)"
                onChange={(e) => {
                  set_alternator_bearing_temp(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Auxiliary Engine comments</label>
              <TextArea
                disabled
                rows={6}
                placeholder="Auxiliary Engine comments"
                maxLength={1000}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuxiliryEngineLog;
